import { motion } from 'framer-motion';
import { Alert } from 'antd';
import React, { useEffect } from 'react';
import { hideAuthMessage } from '../../../redux/actions';
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../redux/selector';

interface ErrorMessageProps {}

const ErrorMessage: React.FC<ErrorMessageProps> = ({}) => {
  const { message } = useAuthState();
  const dispatch = useDispatch();
  const showMessage = message.length > 0;
  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideAuthMessage());
      }, 5000);
    }
  }, [dispatch, message, showMessage]);

  return (
    <motion.div
      initial={{ opacity: 0, marginTop: 0, marginBottom: 0 }}
      animate={{
        opacity: showMessage ? 1 : 0,
        marginTop: showMessage ? 10 : 0,
        marginBottom: showMessage ? 20 : 0,
      }}
    >
      <Alert type="error" showIcon message={message} />
    </motion.div>
  );
};

export default ErrorMessage;
